export default __webpack_public_path__ + "static/productivity-69de26805948d497617494fa99f12078.svg";